import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import Panel from "../components/Panel";
import KpiCard from "../components/KpiCard";
import { fmtINR } from "../lib/format";

const STATUS_COLOR = { "Active": "#4af6c3", "Idle": "#ff433d", "Under Repair": "#fb8b1e" };

export default function Equipment() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/equipment").then((r) => setData(r.data)); }, []);
    if (!data) return <div className="font-mono-fin text-sm text-[var(--text-secondary)]">// LOADING EQUIPMENT...</div>;

    return (
        <div className="space-y-4">
            <div>
                <div className="font-mono-fin text-[10px] uppercase tracking-[0.25em] text-[var(--brand-amber)] mb-1">// EQUIPMENT MANAGEMENT</div>
                <h1 className="font-display font-black text-3xl">Fleet Utilization</h1>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                <KpiCard testId="eq-capex" label="Total CAPEX" value={data.summary.total_capex} sub={`${data.equipment.length} assets`} accent />
                <KpiCard testId="eq-util" label="Avg Utilization" value={`${data.summary.avg_utilization.toFixed(1)}%`} format="custom" sub="Target 75%" />
                <KpiCard testId="eq-idle" label="Idle Assets" value={data.summary.idle_count} format="custom" sub="<50% util" />
                <KpiCard testId="eq-margin" label="Monthly Fleet Margin" value={data.summary.monthly_revenue - data.summary.monthly_cost} sub={`Rev ${fmtINR(data.summary.monthly_revenue)}`} />
            </div>

            <Panel testId="eq-list" title="Asset Register">
                <div className="overflow-x-auto">
                    <table className="w-full font-mono-fin text-xs">
                        <thead className="border-b border-panel">
                            <tr className="text-[10px] uppercase tracking-wider text-[var(--text-secondary)]">
                                <th className="text-left py-2">Asset</th>
                                <th className="text-left">Type</th>
                                <th className="text-left">Site</th>
                                <th className="text-right">Utilization</th>
                                <th className="text-right">Downtime</th>
                                <th className="text-right">Fuel</th>
                                <th className="text-right">Cost/hr</th>
                                <th className="text-right">Rev/hr</th>
                                <th className="text-left">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.equipment.map((e) => (
                                <tr key={e.id} className="border-b border-[var(--border)]/50 hover:bg-[var(--bg-panel-hover)]">
                                    <td className="py-2 text-[var(--text-primary)]">{e.name}</td>
                                    <td className="text-[var(--text-secondary)]">{e.type}</td>
                                    <td className="text-[var(--text-secondary)] text-[10px] uppercase">{e.site}</td>
                                    <td className="text-right">
                                        <div className="inline-flex items-center gap-2 justify-end">
                                            <div className="w-16 h-1 bg-[var(--bg-base)] border border-panel">
                                                <div className="h-full" style={{ width: `${e.utilization_pct}%`, background: e.utilization_pct >= 75 ? "#4af6c3" : e.utilization_pct >= 50 ? "#fb8b1e" : "#ff433d" }} />
                                            </div>
                                            <span className={e.utilization_pct >= 75 ? "text-pos" : e.utilization_pct >= 50 ? "text-amber" : "text-neg"}>{e.utilization_pct}%</span>
                                        </div>
                                    </td>
                                    <td className={`text-right ${e.downtime_hrs_mtd > 30 ? "text-neg" : "text-[var(--text-secondary)]"}`}>{e.downtime_hrs_mtd}h</td>
                                    <td className="text-right text-[var(--text-secondary)]">{e.fuel_ltrs_mtd}L</td>
                                    <td className="text-right text-[var(--text-primary)]">₹{e.cost_per_hr}</td>
                                    <td className="text-right text-pos">₹{e.revenue_per_hr}</td>
                                    <td><span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 border" style={{ borderColor: STATUS_COLOR[e.status], color: STATUS_COLOR[e.status] }}>{e.status}</span></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Panel>
        </div>
    );
}
